import React          from 'react'
import ReactDOM       from 'react-dom'
import BaseController from 'controllers/base'
import                     'scrollpos-styler/scrollPosStyler.js'
import CalculatorsFAQ from '../../containers/Calculators/components/CalculatorsFAQ';
import RefinanceCalculator from '../../containers/Calculators/RefinanceCalculator';
import RatesPills from '../../containers/Calculators/components/RatesPills';
import {refinanceCalculatorFaqs} from './faqs/calculatorsFAQs';

class Controller extends BaseController {
  call() {
    super.call();
    bindNavbarCollapsable.call(this);

    if (document.getElementById("react-root")) {
      ReactDOM.render(<RefinanceCalculator />, document.getElementById("react-root"))
    }
    if (document.getElementById("faq-card")) {
      ReactDOM.render(<CalculatorsFAQ faqs={refinanceCalculatorFaqs}/>, document.getElementById("faq-card"))
    }
    if (document.getElementById("rates-pills")) {
      ReactDOM.render(<RatesPills />, document.getElementById("rates-pills"))
    }
  }
};

// This adds/remove the class `navbar-collapsable-show` on the main nav
let bindNavbarCollapsable = function() {
  $('#navbarSupportedContent').on('show.bs.collapse', function () {
    $('.navbar-pages').addClass('navbar-collapsable-show')
  })

  $('#navbarSupportedContent').on('hidden.bs.collapse', function () {
    $('.navbar-pages').removeClass('navbar-collapsable-show')
  })
}

export default Controller;
